import React from 'react';
import Machine from '../../engine/MachineSubject';
import Metronome from '../../engine/MetronomeSubject';
import { Box } from '../Box';
import styled from '../../styled';
import { Slot } from '../Slot';
import { Button } from '../Button';

const PlaybackStyles = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  height: 100%;
`;

const Playback: React.FC<{ octave: number }> = ({ octave = 4 }) => {
  return (
    <PlaybackStyles>
      <Slot placement="1 / 1 / span 1 / span 1">
        <Button />
      </Slot>
      <Slot placement="1 / 2 / span 1 / span 1">
        <Button />
      </Slot>
      <Slot placement="1 / 3 / span 1 / span 1">
        <Button />
      </Slot>

      <Slot placement="2 / 1 / span 1 / span 1">
        <Button onClick={() => Metronome.enable()}>
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path d="m73.242 37.223 9.7578-11.457c-1.1016-1.5352-1.75-3.418-1.75-5.4531 0-5.1758 4.1992-9.375 9.375-9.375s9.375 4.1992 9.375 9.375-4.1992 9.375-9.375 9.375c-2.0117 0-3.875-0.63281-5.4023-1.7109l-10.387 12.191 21.285 39.293c0.49609 0.91406 0.75391 1.9375 0.75391 2.9766v6.625c0 3.4531-2.7969 6.25-6.25 6.25h-84.375c-3.4531 0-6.25-2.7969-6.25-6.25v-6.625c0-1.0391 0.25781-2.0625 0.75391-2.9766l38.73-71.5c1.0938-2.0156 3.2031-3.2734 5.4961-3.2734h6.9141c2.293 0 4.4023 1.2578 5.4961 3.2734zm14.367 33.09h-78.344l-5.7617 10.637c-0.25 0.45703-0.37891 0.96875-0.37891 1.4883v6.625c0 1.7266 1.3984 3.125 3.125 3.125h84.375c1.7266 0 3.125-1.3984 3.125-3.125v-6.625c0-0.51953-0.12891-1.0312-0.37891-1.4883zm-35.789-3.125h34.098l-13.254-24.469zm-4.1055 0 23.355-27.414-16.426-30.324c-0.54688-1.0078-1.6016-1.6367-2.75-1.6367h-6.9141c-1.1484 0-2.2031 0.62891-2.75 1.6367l-31.273 57.738zm42.91-40.625c3.4531 0 6.25-2.7969 6.25-6.25s-2.7969-6.25-6.25-6.25-6.25 2.7969-6.25 6.25 2.7969 6.25 6.25 6.25z" />
          </svg>
        </Button>
      </Slot>
      <Slot placement="2 / 2 / span 1 / span 1">
        <Button onClick={() => Machine.setOctave(octave - 1)}>
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path d="m34.898 49.398c0-0.60156 0.19922-1.1992 0.69922-1.8008 3.8008-3.8008 7.6992-7.6992 11.5-11.5 2.3008-2.3008 5.8008 1.1992 3.5 3.5-2.5 2.5-4.8984 4.8984-7.3984 7.3984h41.199c0.60156 0 1.1992 0.19922 1.5 0.5 0.60156 0.39844 1 1.1016 0.89844 2-0.097656 13.703-6.9961 26.402-18.898 33.504-21.797 12.898-50.898 1.1016-57.5-23.398-6.5977-24.703 12.5-48.602 37.602-49.102 3.1992-0.10156 3.1992 4.8984 0 5-13.801 0.30078-26.398 8.3984-31.5 21.301-5 12.5-1.8984 27.102 7.5 36.602 9.5 9.5977 24.102 12.598 36.602 7.5977 12.102-4.8008 20.102-16.301 21.199-29h-38.301l7.3984 7.3984c2.3008 2.3008-1.3008 5.8008-3.5 3.5l-11.801-11.801c-0.49609-0.49609-0.69922-1.0977-0.69922-1.6992z" />
          </svg>
        </Button>
      </Slot>
      <Slot placement="2 / 3 / span 1 / span 1">
        <Button onClick={() => Machine.setOctave(octave + 1)}>
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path d="m66.301 50.301c0-0.60156-0.19922-1.1992-0.69922-1.8008-3.8008-3.8008-7.6992-7.6992-11.5-11.5-2.3008-2.3008-5.8008 1.1992-3.5 3.5l7.3984 7.3984h-41.199c-0.60156 0-1.1992 0.19922-1.5 0.5-0.60156 0.39844-1 1.1016-0.89844 2 0.30078 13.699 7.1992 26.5 19.102 33.5 21.598 12.902 50.695 1.1016 57.297-23.398 6.6016-24.699-12.5-48.602-37.602-49.102-3.1992-0.10156-3.1992 4.8984 0 5 13.801 0.30078 26.398 8.3984 31.5 21.301 5 12.5 1.8984 27.102-7.5 36.602-9.5 9.5-24.102 12.5-36.602 7.5-12.102-4.8008-20.102-16.301-21.199-29h38.301l-7.3984 7.3984c-2.3008 2.3008 1.3008 5.8008 3.5 3.5l11.801-11.801c0.5-0.39844 0.69922-1 0.69922-1.5977z" />
          </svg>
        </Button>
      </Slot>

      <Slot placement="3 / 1 / span 1 / span 1">
        <Button>
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="m66.508 92.77c-5.2656 2.0312-10.816 3.0625-16.508 3.0625-25.273 0-45.832-20.559-45.832-45.832 0-8.4648 2.3242-16.734 6.7266-23.914 0.60156-0.98047 0.29297-2.2617-0.6875-2.8633-0.98047-0.60156-2.2617-0.29297-2.8633 0.6875-4.8047 7.8359-7.3438 16.855-7.3438 26.09 0 27.57 22.43 50 50 50 6.207 0 12.266-1.125 18.008-3.3398 1.0742-0.41406 1.6055-1.6211 1.1953-2.6953-0.41406-1.0742-1.625-1.6016-2.6953-1.1953z" />
              <path d="m50 0c-13.355 0-25.914 5.2031-35.355 14.645-0.81641 0.81641-0.81641 2.1328 0 2.9453 0.81641 0.81641 2.1328 0.81641 2.9453 0 8.6562-8.6562 20.168-13.422 32.41-13.422 25.273 0 45.832 20.559 45.832 45.832 0 16.078-8.1953 30.699-21.922 39.109-0.98047 0.60156-1.2891 1.8828-0.6875 2.8633 0.39062 0.64062 1.0781 0.99609 1.7773 0.99609 0.37109 0 0.74609-0.097656 1.0859-0.30469 14.973-9.1758 23.914-25.125 23.914-42.664 0-27.57-22.43-50-50-50z" />
              <path d="m70.832 50c0 11.508-9.3242 20.832-20.832 20.832s-20.832-9.3242-20.832-20.832 9.3242-20.832 20.832-20.832 20.832 9.3242 20.832 20.832" />
            </g>
          </svg>

        </Button>
      </Slot>
      <Slot placement="3 / 2 / span 1 / span 1">
        <Button color="primary" onClick={() => Machine.play()}>
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="m94.445 27.109c-3.5547-6.7773-8.5547-12.777-14.777-17.332-0.89062-0.66797-2.2227-0.44531-2.8906 0.44531-0.66797 0.89062-0.44531 2.2227 0.44531 2.8906 5.668 4.2227 10.332 9.668 13.555 15.891 3.332 6.5547 5.1094 13.555 5.1094 21 0 25.332-20.555 45.891-45.891 45.891-25.328-0.003906-45.887-20.562-45.887-45.895s20.559-45.891 45.891-45.891c1.1094 0 2-0.89062 2-2s-0.89062-2.1094-2-2.1094c-27.555 0-50 22.445-50 50s22.445 50 50 50 50-22.445 50-50c0-8-1.8906-15.891-5.5547-22.891z" />
              <path d="m37.223 26.777c-0.66797 0.33203-1 1-1 1.7773v44.668c0 1.1094 0.89062 2 2 2s2-0.89062 2-2v-41.109l30.109 17.891-22.109 14.328c-1 0.55469-1.2227 1.8906-0.55469 2.7773 0.55469 1 1.8906 1.2227 2.7773 0.55469l24.891-16c0.55469-0.33203 1-1 0.89062-1.7773 0-0.66797-0.33203-1.332-1-1.668l-36.004-21.441c-0.55469-0.33203-1.332-0.33203-2 0z" />
            </g>
          </svg>
        </Button>
      </Slot>
      <Slot placement="3 / 3 / span 1 / span 1">
        <Button color="error" onClick={() => Machine.stop()}>
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="m50 100c-27.5 0-50-22.5-50-50s22.5-50 50-50 50 22.5 50 50-22.5 50-50 50zm0-95c-24.75 0-45 20.25-45 45s20.25 45 45 45 45-20.25 45-45-20.25-45-45-45z" />
              <path d="m67.5 70h-35c-1.5 0-2.5-1-2.5-2.5v-35c0-1.5 1-2.5 2.5-2.5h17.5c1.5 0 2.5 1 2.5 2.5s-1 2.5-2.5 2.5h-15v30h30v-30h-2c-1.5 0-2.5-1-2.5-2.5s1-2.5 2.5-2.5h4.5c1.5 0 2.5 1 2.5 2.5v35c0 1.5-1 2.5-2.5 2.5z" />
            </g>
          </svg>
        </Button>
      </Slot>
    </PlaybackStyles>
  );
}

export { Playback };
